import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { ReactComponent as ArrowRightCircle } from '../../assets/icons/arrow-right-circle.svg';
import { ReactComponent as ArrowUpRight } from '../../assets/icons/arrow-up-right.svg';
import { ReactComponent as Buildings } from '../../assets/icons/buildings.svg';
import { ReactComponent as Car } from '../../assets/icons/car.svg';
import { ReactComponent as ChartHistogram } from '../../assets/icons/chart-histogram.svg';
import { ReactComponent as Check } from '../../assets/icons/check.svg';
import { ReactComponent as CheckCircle } from '../../assets/icons/check-circle.svg';
import { ReactComponent as ChevronDown } from '../../assets/icons/chevron-down.svg';
import { ReactComponent as ChevronRight } from '../../assets/icons/chevron-right.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as Dashboard } from '../../assets/icons/dashboard.svg';
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as Gauge } from '../../assets/icons/gauge.svg';
import { ReactComponent as Hierarchy } from '../../assets/icons/hierarchy.svg';
import { ReactComponent as Instagram } from '../../assets/icons/instagram.svg';
import { ReactComponent as Linkedin } from '../../assets/icons/linkedin.svg';
import { ReactComponent as Menu } from '../../assets/icons/menu.svg';
import { ReactComponent as Quote } from '../../assets/icons/quote.svg';
import { ReactComponent as ShieldKey } from '../../assets/icons/shield-key.svg';
import { ReactComponent as Sparkle } from '../../assets/icons/sparkle.svg';
import { ReactComponent as Star } from '../../assets/icons/star.svg';
import { ReactComponent as StarHalf } from '../../assets/icons/star-half.svg';
import { ReactComponent as Ticket } from '../../assets/icons/ticket.svg';
import { ReactComponent as TwitterX } from '../../assets/icons/twitter-x.svg';
import { ReactComponent as UserCheck } from '../../assets/icons/user-check.svg';
import { ReactComponent as XCircle } from '../../assets/icons/x-circle.svg';

/**
 * Icons are inlined as components (CRA's SVGR) rather than <img>, so they can
 * inherit `currentColor` and be sized from CSS. All are 24x24 with a viewBox.
 */
const ICONS = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-right-circle': ArrowRightCircle,
  'arrow-up-right': ArrowUpRight,
  buildings: Buildings,
  car: Car,
  'chart-histogram': ChartHistogram,
  check: Check,
  'check-circle': CheckCircle,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  close: Close,
  dashboard: Dashboard,
  facebook: Facebook,
  gauge: Gauge,
  hierarchy: Hierarchy,
  instagram: Instagram,
  linkedin: Linkedin,
  menu: Menu,
  quote: Quote,
  'shield-key': ShieldKey,
  sparkle: Sparkle,
  star: Star,
  'star-half': StarHalf,
  ticket: Ticket,
  'twitter-x': TwitterX,
  'user-check': UserCheck,
  'x-circle': XCircle,
};

export const iconNames = Object.keys(ICONS);

export function Icon({ name, size = 24, label, className, ...rest }) {
  const Svg = ICONS[name];
  if (!Svg) {
    if (process.env.NODE_ENV === 'development') console.warn(`Unknown icon: ${name}`);
    return null;
  }
  return (
    <Svg
      width={size}
      height={size}
      className={className}
      // Decorative by default; pass `label` only when the icon carries meaning
      // no adjacent text already conveys.
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...rest}
    />
  );
}
